import { render, staticRenderFns } from "./SliderNews.vue?vue&type=template&id=39d3193d&scoped=true&"
import script from "./SliderNews.vue?vue&type=script&lang=js&"
export * from "./SliderNews.vue?vue&type=script&lang=js&"
import style0 from "./SliderNews.vue?vue&type=style&index=0&id=39d3193d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d3193d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d3193d')) {
      api.createRecord('39d3193d', component.options)
    } else {
      api.reload('39d3193d', component.options)
    }
    module.hot.accept("./SliderNews.vue?vue&type=template&id=39d3193d&scoped=true&", function () {
      api.rerender('39d3193d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/SliderNews.vue"
export default component.exports